// This import loads the firebase namespace along with all its type information.
import MediaSnapshot from './media-snapshot-model'

export async function load_mediaSnapshots(): Promise<MediaSnapshot[]> {
  throw 'Not implemented'
}

export async function delete_mediaSnapshot(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaSnapshot(): Promise<MediaSnapshot> {
  throw 'Not implemented'
}
